import React, { useContext } from "react";
import MetaTags from "react-meta-tags";

//import Breadcrumbs
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Col, Container, Row } from "reactstrap";
import Templates from "./Templates";
import { ThemeContext } from "src/helpers/themeContext";

const TemplatesPage = () => {
console.log("TemplatesPage started")
const Theme = useContext(ThemeContext)
    return (
        
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Templates | {Theme.name} templates</title>
                </MetaTags>

                <Container fluid>
                    {/* Render Breadcrumbs */}
                    <Breadcrumbs title="Home" breadcrumbItem="Templates" />

                    <Row>
                        <Col lg={12}>
                            <Templates />
                        </Col>
                    </Row>

                    
                </Container>
            </div>
        </React.Fragment>
    );
}

export default TemplatesPage;